//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  data() {
    return {
      form: this.$route.query.form,
      list_ary: [],
      loading: false,
      tv_show: false,
      route: ""
    };
  },
  mounted() {
    let formData = new FormData();
    formData.append("action_type", "get_pdf_file");
    formData.append("form", this.$route.query.form);
    if (this.$route.query.type) {
      formData.append("type_id", this.$route.query.type);
    }

    formData.append("orderByObj", "id");
    formData.append("orderBy", "desc");
    this.loading = true;
    this.$http({
      url: "/search/common.php",
      method: "post",
      data: formData
    }).then(res => {
      this.loading = false;
      this.list_ary = res.data.data;
    });
  },
  components: {},
  methods: {
    push(item) {
      this.route = mediaUrl + item.route;
      this.tv_show = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/list_tv.vue